import styled from '@emotion/styled';

export const AZResumeStep = styled.div`
  .ant-upload.ant-upload-drag {
    background: #fff;
  }
`;
